import { useNavigate, useLocation } from 'react-router-dom';
import GlobalError from '../components/GlobalError';
import { useSnackbar } from '../contexts/SnackbarProvider';
import useDataFetch from '../hooks/useDataFetch';
import useDataSelect from '../hooks/useDataSelect';
import { getFields, searchFields } from '../utils/fields';
import { formatDateTime, formatCurrency } from '../utils/format';
import SearchForm from '../components/SearchForm';
import TableView from '../components/TableView';
import Pagination from '../components/Pagination';
import RelatedMenu from '../components/RelatedMenu';
import { Paper, Button, Link, Typography } from "@mui/material";
const PurchasePage = ({ hasLimit }) => {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();

  const initialStatus = location.state?.filterStatus
    ? (typeof location.state.filterStatus === 'string'
      ? location.state.filterStatus.split(',').map(Number) // '2,3' → [2,3]
      : [location.state.filterStatus])
    : []; // デフォルト

  const { dataset: statuses } = useDataSelect('/purchase/statuses');
  const {
    dataset,
    error,
    currentPage,
    totalPages,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
  } = useDataFetch('/purchase', { numbers: '', supplier_name: '', dates: '', status: initialStatus });

  // 行クリック時にページ遷移を行う処理
  const handleDetail = async (item) => {
    navigate(`/purchases/${item.id}`); // 発注詳細ページに遷移
  };

  // 検索フィールド定義
  const fieldsToInclude = ['dates', 'numbers', 'supplier_name'];
  let searchItems = getFields(searchFields, fieldsToInclude);
  searchItems = [
    ...searchItems,
    {
      name: 'status',
      type: 'select',
      label: 'ステータス',
      options: statuses.map((item) => ({
        value: item.status_id,
        label: item.status_name,
      }))
    },
  ];

  const columns = [
    {
      label: '発注日',
      accessor: 'date',
      format: (date) => formatDateTime(date),
      width: '140px',
    },
    {
      label: '発注番号',
      accessor: 'number',
      render: (item) => (
        <Link
          component="button"
          onClick={() => handleDetail(item)}>
          {item.number}
        </Link>
      ),
      width: '140px',
    },
    {
      label: 'ステータス',
      accessor: 'status_name',
      width: '140px',
    },
    {
      label: '金額',
      accessor: 'total_amount',
      render: (item) => (
        <>
          {formatCurrency(item.total_amount)}<br />
          <Typography variant="caption">税込 {formatCurrency(item.total_amount_including_tax)}</Typography>
        </>
      ),
      width: '140px',
    },
    {
      label: '会社名',
      accessor: 'supplier_name',
      render: (item) => (
        <Typography>
          {item.supplier_name}
        </Typography>
      ), width: '350px',
    },
    {
      label: '',
      render: (item) => (
        <Button
          size="small"
          variant="outlined"
          onClick={() => handleDetail(item)}>
          詳細
        </Button>
      ),
      width: '50px',
    },
  ];
  const links = [
    { path: '/purchases/new', label: '新規発注作成', icon: 'library_add' },
  ];

  if (error) return <GlobalError errorMessage={error} />;
  return (
    <>
      <Typography variant="h1" component="h1">発注一覧</Typography>
      <div className='grid2-2_1'>
        {/* 検索フォーム */}
        <SearchForm
          searchQuery={searchQuery}
          searchFields={searchItems}
          handleSearchChange={handleSearchChange}
          handleSearchSubmit={handleSearchSubmit}
          handleClearSearch={handleClearSearch}
        />
        <RelatedMenu links={links} />
      </div>
      <Paper variant='section'>
        <TableView dataset={dataset} columns={columns} keyColumn="id" />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </Paper>
    </>
  );
};
export default PurchasePage;
